import { FormSpy } from 'react-final-form';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useCurrentUser } from 'src/app/shared/hooks/session';

import type { FormRenderProps, PetitionUpdateFormValues } from '../../types';
import { DescriptionTextArea } from '../DescriptionTextArea';
import { ErrorMessage } from '../ErrorMessage';
import { ImageUploadContainer } from '../ImageUploadContainer';
import { PreviewModal } from '../PreviewModal';
import { SubmitButton } from '../SubmitButton';
import { TitleInput } from '../TitleInput';

type FormRenderPropsReskin = Omit<FormRenderProps, 'onPreview'> & {
	onPreview: () => void;
};

export function FormRender({
	handleSubmit,
	initialValues,
	hasValidationErrors,
	onPreview,
	isCurrentlyLoading,
	uploader,
	error,
}: FormRenderPropsReskin) {
	const {
		data: {
			petition: { displayTitle },
		},
	} = useStarterDashboardV2PageData();
	const currentUser = useCurrentUser();
	return (
		<form onSubmit={handleSubmit} autoComplete="off" className="mt-6" data-qa="petition-update-form">
			<div className="flex flex-col flex-wrap justify-end gap-8 md:flex-row">
				<TitleInput initialValue={initialValues.title} />
				<ImageUploadContainer uploader={uploader} />
				<DescriptionTextArea initialValue={initialValues.description} />
				{error && <ErrorMessage errorType={error} />}
				<FormSpy<PetitionUpdateFormValues> subscription={{ values: true }}>
					{({ values }) => (
						<div className="flex w-full flex-col flex-wrap justify-end gap-4 md:flex-row">
							<PreviewModal
								onPreview={onPreview}
								emailTitle={values.title || ''}
								emailContent={values.description || ''}
								petitionTitle={displayTitle}
								emailImageUrl={values.embeddedMediaUrl}
								userName={currentUser?.displayName || ''}
								disabled={hasValidationErrors || isCurrentlyLoading}
							/>
							<SubmitButton
								data-qa="petition-update-submit-button"
								hasValidationErrors={hasValidationErrors}
								loading={isCurrentlyLoading}
							/>
						</div>
					)}
				</FormSpy>
			</div>
		</form>
	);
}
